import React, { useState } from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
// after all edition now we can add UseAuth:
import { UserAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  //we use useState to toggle the menu
  const [nav, setNav] = useState(false);

  // for logout:  later we add***
  const { user, logout } = UserAuth();
  const navigate = useNavigate();

  // arrrow function to toggle the menu
  const handleNav = () => {
    // put setnav to ture:
    setNav(!nav);
  };

  // for working of submit button:
  // create a function to handle logout:
  const handleSignOut = async () => {
    try {
      await logout();
      navigate("/");
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <div className="rounded-div flex items-center justify-between h-20 font-bold">
      <Link to="/">
        <h1 className="text-2xl">Cryptobase</h1>
      </Link>
      {/* az ye heighti bishtar hidden kon: */}
      <div className="hidden md:block">
        <ThemeToggle />
      </div>

      {/* signin and signup links: */}

      {user?.email ? (
        <div>
          <Link to="/account" className="p-4">
            Account
          </Link>
          <button onClick={handleSignOut}>SignOut</button>
        </div>
      ) : (
        <div className="hidden md:block">
          <Link to="/signin" className="p-4 hover:text-accent">
            Sign In
          </Link>
          <Link
            to="/signup"
            className="bg-button text-btnText px-5 py-2 ml-2 rounded-2xl shadow-lg hover:shadow-2xl"
          >
            Sign Up
          </Link>
        </div>
      )}

      {/* *****menu icon: this is icon un 3 khate*/}
      <div onClick={handleNav} className="block md:hidden cursor-pointer z-10">
        {/* if nav is true: */}
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>

      {/* *****mobile menu: icon hamun rasti*/}
      <div
        className={
          nav
            ? "md:hidden fixed left-0 top-20 flex flex-col items-center justify-between  w-full h-[90%] bg-primary ease-in duration-300 z-10"
            : "fixed left-[-100%] top-20 h-[90%] flex flex-col items-center justify-between ease-in duration-300 "
        }
      >
        <ul className="w-full p-4 ">
          <li onClick={handleNav} className="border-b py-6">
            <Link to="/">Home</Link>
          </li>
          <li onClick={handleNav} className="border-b py-6">
            {/* Account would be protected route: */}
            <Link to="/account">Account</Link>
          </li>
          <li className=" py-6">
            <ThemeToggle />
          </li>
        </ul>
        {/*  a button */}
        <div className="flex flex-col w-full p-4">
          <Link to="/signin">
            <button
              onClick={handleNav}
              className="w-full my-2 p-3 bg-primary text-primary border border-primary rounded-2xl shadow-xl"
            >
              Sign In
            </button>
          </Link>
          <Link to="/signup">
            <button
              onClick={handleNav}
              className=" w-full my-2 p-3 bg-button text-btnText rounded-2xl shadow-xl"
            >
              Sign Up
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

// create theme toggle button:
// when clicked, the theme changes to dark mode

// ctrl + space: auto complete
